import React from 'react';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

export default function ToastMenssenger(){
  return (
    <ToastContainer
      position="top-center"
      autoClose={1300}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      //icon={false}                                  
      >
  </ToastContainer>
  );
}